import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SideMenuService {
  private sideMenuSubject: Subject<boolean>;

  getSideMenuSubject(): Observable<boolean> {
    if (!this.sideMenuSubject) {
      this.sideMenuSubject = new Subject<boolean>();
    }
    return this.sideMenuSubject.asObservable();
  }

  toggleSideMenu(isOpen?: boolean) {
    this.sideMenuSubject.next(isOpen);
  }
}
